<template>
  <div>
    <v-container fluid>
      <v-row align="center">
        <v-select
          :items="this.$store.state.cities"
          label="City"
          @change="fetchApiData_automationConfig()"
          v-model="CITY"
        ></v-select>
      </v-row>
      <v-row align="center">
        <v-col cols="8" sm="10"> </v-col>
        <v-col cols="2" sm="1">
          <AutoAddNewData v-bind:ITEM="ITEM"></AutoAddNewData>
        </v-col>
        <v-col cols="2" sm="1">
          <v-btn
            icon
            color="green"
            large
            @click="fetchApiData_automationConfig()"
          >
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      dense
      hide-default-footer
      disable-pagination
      fixed-header
      height="600px"
      :sort-by="['CITY_RESTAURANT_LANG']"
      :sort-desc="[false]"
      :headers="headers"
      :items="AUTO_CONFIGS"
      :mobile-breakpoint="100"
    >
      <!-- TYPE -->
      <template v-slot:item.TYPE="props">
        <v-edit-dialog
          :return-value.sync="props.item.TYPE"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.TYPE }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.TYPE"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- POS -->
      <template v-slot:item.POS="props">
        <v-edit-dialog
          :return-value.sync="props.item.POS"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.POS }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.POS"
              label="Edit"
              single-line
              :rules="[rules.is_number]"
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- MA -->
      <template v-slot:item.MA="props">
        <v-edit-dialog
          :return-value.sync="props.item.MA"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.MA }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.MA"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- TI -->
      <template v-slot:item.TI="props">
        <v-edit-dialog
          :return-value.sync="props.item.TI"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.TI }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.TI"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <!-- KE -->
      <template v-slot:item.KE="props">
        <v-edit-dialog
          :return-value.sync="props.item.KE"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.KE }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.KE"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- TO -->
      <template v-slot:item.TO="props">
        <v-edit-dialog
          :return-value.sync="props.item.TO"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.TO }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.TO"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- PE -->
      <template v-slot:item.PE="props">
        <v-edit-dialog
          :return-value.sync="props.item.PE"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.PE }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.PE"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- LA -->
      <template v-slot:item.LA="props">
        <v-edit-dialog
          :return-value.sync="props.item.LA"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.LA }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.LA"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- SU -->
      <template v-slot:item.SU="props">
        <v-edit-dialog
          :return-value.sync="props.item.SU"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.SU }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.SU"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- CLOSE -->
      <template v-slot:item.CLOSE="props">
        <v-edit-dialog
          :return-value.sync="props.item.CLOSE"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.CLOSE }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.CLOSE"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- SPLITTER -->
      <template v-slot:item.SPLITTER="props">
        <v-edit-dialog
          :return-value.sync="props.item.SPLITTER"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.SPLITTER }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.SPLITTER"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- URL_LINK -->
      <template v-slot:item.URL_LINK="props">
        <v-edit-dialog
          :return-value.sync="props.item.URL_LINK"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.URL_LINK }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.URL_LINK"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- RUNTIME -->
      <template v-slot:item.RUNTIME="props">
        <v-edit-dialog
          :return-value.sync="props.item.RUNTIME"
          large
          @save="saveanddeleteold(props.item)"
          @cancel="cancel"
          @open="saveoldruntime(props.item)"
          @close="close"
        >
          {{ props.item.RUNTIME }}
          <template v-slot:input>
            <p>
              <b>Syntax :</b>"day"-"time"<br />, where Sunday=0, Monday=1
              etc.<br />
              For time only flat hours are supported.<br />
              If you don't want to run the automation change day to 9. For
              example: 9-12
            </p>
            <v-text-field
              v-model="props.item.RUNTIME"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- URL_LINK_AUTOMATION -->
      <template v-slot:item.URL_FOR_AUTOMATION="props">
        <v-edit-dialog
          :return-value.sync="props.item.URL_FOR_AUTOMATION"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.URL_FOR_AUTOMATION }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.URL_FOR_AUTOMATION"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- FUNCTION -->
      <template v-slot:item.FUNCTION="props">
        <v-edit-dialog
          :return-value.sync="props.item.FUNCTION"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.FUNCTION }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.FUNCTION"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- CITY -->
      <template v-slot:item.CITY="props">
        <v-edit-dialog
          :return-value.sync="props.item.CITY"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.CITY }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.CITY"
              :rules="[max80chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- Actions -->
      <template v-slot:item.actions="{ item }">
        <v-row justify="space-around">
          <v-icon @click="duplicateItem(item)"> mdi-content-copy </v-icon>

          <v-icon @click="testItem(item)" color="teal darken-2">
            mdi-test-tube
          </v-icon>

          <v-icon @click="deleteItem(item)" color="red darken-2">
            mdi-delete
          </v-icon>
        </v-row>

        <v-dialog v-model="dialogTest" max-width="500px" :retain-focus="false">
          <v-card>
            <v-card-title class="text-h5"
              >Raw output from the function</v-card-title
            >
            <v-card-text>{{ RAW_OUTPUT }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="applyToDB"
                >Apply to database</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeTest">Close</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogDelete"
          max-width="500px"
          :retain-focus="false"
        >
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-text
              >Restaurant: {{ ITEM.CITY_RESTAURANT_LANG }}, RUNTIME:{{
                ITEM.RUNTIME
              }}</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AutoAddNewData from "./autoAddNewData";

export default {
  name: "AutoConfigTables",
  components: { AutoAddNewData },
  data() {
    return {
      dialogDelete: false,
      dialogTest: false,
      snack: false,
      snackColor: "",
      snackText: "",
      max80chars: (v) => v.length <= 80 || "Input too long!",
      RAW_OUTPUT: "",
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        {
          text: "CITY_RESTAURANT_LANG",
          align: "start",
          style: "bold",
          value: "CITY_RESTAURANT_LANG",
        },
        { text: "TYPE", value: "TYPE" },
        { text: "POS", value: "POS" },
        { text: "MA", value: "MA" },
        { text: "TI", value: "TI" },
        { text: "KE", value: "KE" },
        { text: "TO", value: "TO" },
        { text: "PE", value: "PE" },
        { text: "LA", value: "LA" },
        { text: "SU", value: "SU" },
        { text: "CLOSE", value: "CLOSE" },
        { text: "SPLITTER", value: "SPLITTER" },
        { text: "RUNTIME", value: "RUNTIME" },
        { text: "URL_LINK", value: "URL_LINK" },
        { text: "URL_FOR_AUTOMATION", value: "URL_FOR_AUTOMATION" },
        { text: "FUNCTION", value: "FUNCTION" },
        { text: "CITY", value: "CITY" },
      ],
      AUTO_CONFIGS: [],
      CITY: "",
      TEST_ITEM: "",
      ITEM: {
        CITY: "",
        CITY_RESTAURANT_LANG: "",
        TYPE: "",
        POS: "",
        MA: "",
        TI: "",
        KE: "",
        TO: "",
        PE: "",
        LA: "",
        SU: "",
        CLOSE: "",
        SPLITTER: "",
        RUNTIME: "",
        FUNCTION: "",
        URL_FOR_AUTOMATION: "",
        URL_LINK: "",
      },
      oldruntime: "",
      rules: {
        is_number: (value) =>
          parseInt(value) <= 100 || "Must be a number and less than 100.",
      },
    };
  },
  methods: {
    save(item) {
      console.log("SAVE:", item);
      this.postApiData(item);
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveanddeleteold(item) {
      console.log("SAVE:", item);
      if (this.oldruntime != item.RUNTIME) {
        this.deleteAutoConfigItem(item.CITY_RESTAURANT_LANG, this.oldruntime);
        this.postApiData(item);
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
      this.fetchApiData_automationConfig();
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    saveoldruntime(item) {
      this.oldruntime = item.RUNTIME;
      console.log("Old runtime:", this.oldruntime);
      this.open();
    },
    close() {
      console.log("Dialog closed");
    },
    closeDialog() {
      console.log("Dialog closed");
      this.dialog = false;
    },
    closeTest() {
      console.log("Dialog closed");
      this.dialogTest = false;
      this.RAW_OUTPUT = "";
    },
    duplicateItem(item) {
      console.log("Duplicating item.");
      this.ITEM = item;
    },
    deleteItem(item) {
      console.log("ITEM:", item);
      this.ITEM = item;
      this.dialogDelete = true;
    },
    testItem(item) {
      console.log("ITEM:", item);
      this.dialogTest = true;
      this.TEST_ITEM = item;
      this.fetchApiData_automationConfigTest(item, true);
    },
    applyToDB() {
      this.fetchApiData_automationConfigTest(this.TEST_ITEM, false);
      this.RAW_OUTPUT = "DONE.";
      setTimeout(() => {
        this.dialogTest = false;
        this.RAW_OUTPUT = "";
      }, 300);
    },
    deleteItemConfirm() {
      var city_restaurant_lang, runtime;
      city_restaurant_lang = this.ITEM.CITY_RESTAURANT_LANG;
      runtime = this.ITEM.RUNTIME;
      this.deleteAutoConfigItem(city_restaurant_lang, runtime);
      this.closeDelete();
      this.ITEM = "";
      this.fetchApiData_automationConfig();
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    city(value) {
      this.CITY = value;
    },
    restaurants(value) {
      this.RESTAURANTS = value;
    },
    restaurants_selected(value) {
      this.RESTAURANTS_SELECTED = value;
    },
    postApiData(item) {
      var response, url;
      url = this.$store.state.api_url + "automation/basic";
      console.log(url);
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
        body: JSON.stringify(item),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteAutoConfigItem(city_restaurant_lang, runtime) {
      console.log("Deleting item using API");
      var response, url;
      var c_r_l = city_restaurant_lang.replace("&", "%26");
      url =
        this.$store.state.api_url +
        "automation/basic?city_restaurant_lang=" +
        c_r_l +
        "&runtime=" +
        runtime;
      console.log(url);
      fetch(url, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchApiData_cities() {
      console.log("Fetching data");
      var response, url;
      url = this.$store.state.api_url + "info/cities";
      console.log(url);
      fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
            var city_list = [];
            for (var i in data) {
              city_list.push(data[i]["CITY"]);
            }
            this.$store.state.cities = city_list;
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchApiData_automationConfig() {
      var city = this.CITY;
      this.AUTO_CONFIGS = [];
      console.log("CITY:", city);
      var response, url;
      url = this.$store.state.api_url + "automation/basic?city=" + city;
      console.log(url);
      fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
            for (var i in data) {
              this.AUTO_CONFIGS.push(data[i]);
            }
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchApiData_automationConfigTest(item, dry_run) {
      var response, url;
      url = this.$store.state.api_url + "automation/basic/test";
      console.log(url);
      item["DRY_RUN"] = dry_run;
      console.log("ITEM:", item);
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
        body: JSON.stringify(item),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
            this.RAW_OUTPUT = data;
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.fetchApiData_cities();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
p {
  font-size: 10px;
}
a {
  color: #0067a7 !important;
  text-decoration: none;
  font-size: 16px;
}
a:hover {
  color: #0c0c0c;
  text-decoration: underline;
}

.lunch-table-header {
  text-align: center;
  background-color: #e6e6e6;
}

thead {
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
  border: 1px solid #e9ecef;
  padding: 4px;
}

th {
  border-bottom-width: 2px;
  vertical-align: top;
  border-bottom: 2px solid #e9ecef;
  border: 1px solid #e9ecef;
  padding: 4px;
}

td {
  border: 1px solid #e9ecef;
  padding-left: 10px;
}

table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.01rem;
  background-color: transparent;
  border-collapse: collapse;
  border: 1px solid #e9ecef;
  display: table;
  white-space: normal;
  line-height: normal;
  font-weight: normal;
  font-size: medium;
  font-style: normal;
  color: -internal-quirk-inherit;
  text-align: start;
  border-spacing: 2px;
  font-variant: normal;
}

.w-66 {
  width: 66% !important;
}
.w-33 {
  width: 33% !important;
}
</style>
